import { parseTimeOnlyValue } from './parseTimeOnlyValue';
import { parseIsoDateValue } from './parseIsoDateValue';

type ParsedInputDateTime = {
  date: Date;
  isTimeOnly: boolean;
  carriesTime: boolean;
};

// Classifies one date/time input value: time-only (today + parsed time), ISO date/datetime, else null.
export const parseInputDateTimeValue = (
  value: string,
  dateOnly: boolean
): ParsedInputDateTime | null => {
  const timeOnly = dateOnly ? null : parseTimeOnlyValue(value);
  if (timeOnly) return { date: timeOnly, isTimeOnly: true, carriesTime: true };

  const iso = parseIsoDateValue(value);
  if (!iso) return null;

  return { date: iso, isTimeOnly: false, carriesTime: value.includes('T') };
};
